import { PropsWithChildren } from "react";

import { JSMOverlayTemplate } from "@/components/signup/layouts/product-overlay-template";

import { OnboardingContainerProps } from "../../../components";

export const ServCoOnboardingContainer = ({
    header,
    subheader,
    hideSubHeader,
    children,
    size = "lg",
    hideLogo = false,
    isJsmCrossflow
}: OnboardingContainerProps &
    PropsWithChildren & {
        hideLogo?: boolean;
        isJsmCrossflow?: boolean;
    }) => (
    <JSMOverlayTemplate
        header={header}
        subheader={hideSubHeader ? " " : subheader}
        size={size}
        hideLogo={hideLogo}
        isJsmCrossflow={isJsmCrossflow}
    >
        {children}
    </JSMOverlayTemplate>
);
